<style lang="scss">
  @import "@/assets/scss/vuexy/components/minMaxItem";
</style>
<template>
  <div class="m-3 px-2 py-4 border-2 container-item">
      <feather-icon
      icon="EditIcon"
      @click="edit = true"
      class="float-right cursor-pointer"
      svgClasses="h-5 w-5 hover:text-primary"
      v-if="!edit && (url !== undefined && url !== null) && $store.state.AppActiveUser.userRole === 'MA'"/>
      <feather-icon
        v-if="edit"
        @click="edit = false"
        icon="XIcon"
        svgClasses="h-5 w-5 text-grey-ligth"
        class="float-right cursor-pointer hover:text-primary"/>
      <feather-icon
      icon="SaveIcon"
      @click="send()"
      class="float-right cursor-pointer"
      svgClasses="h-5 w-5 hover:text-primary"
      v-if="edit"
      />
      <div class="block text-center mb-2 font-medium">{{title}}</div>
      <div class="block" v-if="!edit">
        <div class="inline-block mr-3 icon-container">
            <img class="h-8 m-auto" :src="getImgUrl(img)" v-if="img" alt=""/>
        </div>
        <div class="inline-block">
            <div>
                <span class="font-bold">{{$t("Labels.Min")}}</span>  {{ setMin }}<span class="unit text-xs">{{unit}}</span>
            </div>
            <div>
                <span class="font-bold">{{$t("Labels.Max")}}</span>  {{ setMax }}<span class="unit text-xs">{{unit}}</span>
            </div>
        </div>
      </div>
      <div class="block container-inputs" v-if="edit">
        <div class="text-center">
            <div>
                <span class="font-bold">{{$t("Labels.Min")}}</span>
                <vs-input-number :min="limitMin" :max="limitMax" v-model="editMin"  class="text-xs"/>
            </div>
            <div>
                <span class="font-bold">{{$t("Labels.Max")}}</span>
                <vs-input-number :min="limitMin" :max="limitMax" v-model="editMax" class="text-xs"/>
            </div>
        </div>
      </div>
  </div>
</template>
<script>
import { request } from '@/request.js'

export default {
  props: {
    min: String,
    max: String,
    unit: String,
    img: String,
    title: String,
    url: String,
    paramMin: String,
    paramMax: String,
    type: String,
    limitMin: {
      type: Number,
      required: true
    },
    limitMax: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      edit: false,
      editMin: 0,
      editMax: 0,
      setMin: 0,
      setMax: 0
    }
  },
  methods: {
    getImgUrl (name) {
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${name}.svg`)
    },
    async send () {
      const params = {
        url: this.url,
        method: this.type,
        params: {}
      }
      params.params[this.paramMin] = this.editMin
      params.params[this.paramMax] = this.editMax

      await request(params).then(() => {
        this.setMin = this.editMin
        this.setMax = this.editMax
      }).finally(() => {
        this.edit = false
      })
    }
  },
  created () {
    this.editMin = this.min
    this.editMax = this.max
    this.setMin = this.min
    this.setMax = this.max
  }
}
</script>
